module.exports = (__parcel__import__("b8mck")).then(() => parcelRequire('fyWP3'));